import React, { useContext, memo } from 'react';

import * as S from './PartnerSliderStyles';
import { Container, Heading, GenericDiv } from '../../../../../common/Styles';
import { isMobileContext } from '../../../../../UtilityComponents/Util';
import DisplayContext from '../../../../../UtilityComponents/displayContext';
import { PartnerIcons } from '../../../Style';
import AutoplaySlider from '../../../../../common/AutoplaySlider/AutoplaySlider';

const PartnerSlider = ({ logos = [], heading }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);

	return (
		<S.PartnerLogosSliderContainer>
			<Container>
				<GenericDiv
					bottom_P={isMobile ? 25 : 50}
					top_P={isMobile ? 25 : 50}
					left_P={isMobile ? 20 : 0}
					right_P={isMobile ? 20 : 0}>
					<Heading
						color='#fff'
						fontSize={`${isMobile ? '40px' : '56px'}`}
						marBt={`${isMobile ? '31px' : '40px'}`}
						dangerouslySetInnerHTML={{ __html: heading }}
					/>
					<S.PartneredCompaniesWrap>
						<S.GradientLeft />
						<>
							{logos && logos.map((logoData, index) => (
								<AutoplaySlider key={index}>
									{logoData.map((item) => (
										<S.PartnerLogoWrap key={item.logo}>
											<PartnerIcons icon={item.logo} />
										</S.PartnerLogoWrap>
									))}
								</AutoplaySlider>
							))}
						</>
						<S.GradientRight />
					</S.PartneredCompaniesWrap>
				</GenericDiv>
			</Container>
		</S.PartnerLogosSliderContainer>
	);
};

export default memo(PartnerSlider);
